import "./Home.css";
import NavBar from "../NavBar";
import Wishes from "../Wishes";
import Footer from "../Footer";
import "bootstrap/dist/css/bootstrap.min.css";

function Home() {
  return (
    <div className="Home">
      <NavBar />
      <div className="content">
        <Wishes />
      </div>
      <Footer />
    </div>
  );
}

export default Home;
